export interface PDFargs {
  rows: any[];
  keys: string[];
}

export function downloadPDF(args: PDFargs) {

  let pdf = convertArrayOfObjectsToPDF(args);
  if (pdf.length == 0) { return; }
  else
    return pdf;
}

function convertArrayOfObjectsToPDF(args: PDFargs) {
  let result = [];

  args.rows.forEach(item => {
    args.keys.forEach(key => {
      result.push(item[key]);
    });
  });
  return result;
}
